// src/App.js
import './App.css';

import React from 'react';
import MovieSearch from './components/MovieSearch';

function App() {
  return (
    <center className="container">
        <MovieSearch />
    </center>
  );
}

export default App;
